import { Alert, Box, CircularProgress } from "@mui/material";
import { observer } from "mobx-react-lite";
import React from "react";
import Diagram from "../../app/component/features/diagram/Diagram";
import { useDiagram } from "../../app/component/features/diagram/useDiagram";
import { useStore } from "../../app/stores/store";

interface Props {
    height: number;
}

function RBDSettingDiagram({ height }: Props) {
    const { rbdItems, loadingDiagram } = useStore().rbdStore
    useDiagram(rbdItems)
    
    return (
        <React.Fragment>
            <Box sx={{mt: 2}} />
            {loadingDiagram
                ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <React.Fragment>
                        {rbdItems.length > 0 
                            ? <Diagram styles={{ height }} />
                            : <Box><Alert severity="info" >There are no diagrams to display</Alert></Box>
                        }
                    </React.Fragment>
                )
            }
        </React.Fragment>
    );
}

export default observer(RBDSettingDiagram);